import { type LoggerProvider } from './logger.provider';
import { type LogContext, type LogLevel } from './logger.types';

export class ScopedLogger {
  constructor(
    private readonly _logger: LoggerProvider,
    private readonly _scope: string,
  ) {}

  public debug(message: string, context?: LogContext): void {
    this._logger.debug(`[${this._scope}] ${message}`, context);
  }

  public log(message: string, context?: LogContext): void {
    this._logger.log(`[${this._scope}] ${message}`, context);
  }

  public info(message: string, context?: LogContext): void {
    this._logger.info(`[${this._scope}] ${message}`, context);
  }

  public warn(message: string, context?: LogContext): void {
    this._logger.warn(`[${this._scope}] ${message}`, context);
  }

  public error(message: string, error?: Error | unknown, context?: LogContext): void {
    this._logger.error(`[${this._scope}] ${message}`, error, context);
  }

  public logWithLevel(level: LogLevel, message: string, context?: LogContext): void {
    this._logger.logWithLevel(level, `[${this._scope}] ${message}`, context);
  }
}
